import { BrowserRouter, Routes, Route } from 'react-router-dom';
import '@/App.css';

import { AuthProvider } from '@/contexts/AuthContext';
import { ProtectedRoute, AdminRoute } from '@/components/Routes';

import Landing from '@/pages/Landing';
import Login from '@/pages/Login';
import Register from '@/pages/Register';
import ForgotPassword from '@/pages/ForgotPassword';
import ResetPassword from '@/pages/ResetPassword';
import Rules from '@/pages/Rules';
import About from '@/pages/About';
import FAQ from '@/pages/FAQ';
import Terms from '@/pages/Terms';
import Privacy from '@/pages/Privacy';
import PlansWizard from '@/pages/PlansWizard';
import Checkout from '@/pages/Checkout';
import PublicCertificate from '@/pages/PublicCertificate';

import AppShell from '@/components/AppShell';
import Dashboard from '@/pages/Dashboard';
import Accounts from '@/pages/Accounts';
import AccountDetail from '@/pages/AccountDetail';
import Payouts from '@/pages/Payouts';
import Certificates from '@/pages/Certificates';
import Affiliate from '@/pages/Affiliate';
import Settings from '@/pages/Settings';

import AdminShell from '@/components/AdminShell';
import TawkVisitor from '@/components/TawkVisitor';
import PromoBanner from '@/components/PromoBanner';
import AdminOverview from '@/pages/admin/AdminOverview';
import AdminUsers from '@/pages/admin/AdminUsers';
import AdminAccounts from '@/pages/admin/AdminAccounts';
import AdminOrders from '@/pages/admin/AdminOrders';
import AdminPhase2Requests from '@/pages/admin/AdminPhase2Requests';
import AdminFundedRequests from '@/pages/admin/AdminFundedRequests';
import AdminPayouts from '@/pages/admin/AdminPayouts';
import AdminAffiliatePayouts from '@/pages/admin/AdminAffiliatePayouts';
import AdminPromotions from '@/pages/admin/AdminPromotions';
import AdminPaymentAgents from '@/pages/admin/AdminPaymentAgents';
import AdminPaymentAgentApplications from '@/pages/admin/AdminPaymentAgentApplications';
import AdminCertificates from '@/pages/admin/AdminCertificates';
import AdminInventory from '@/pages/admin/AdminInventory';
import AnnouncementModal from '@/components/AnnouncementModal';
import PaymentAgents from '@/pages/PaymentAgents';
import PaymentAgentsApply from '@/pages/PaymentAgentsApply';
import AdminImageGenerator from '@/pages/admin/AdminImageGenerator';

function AppRouter() {
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<Login />} />
      <Route path="/register" element={<Register />} />
      <Route path="/forgot" element={<ForgotPassword />} />
      <Route path="/reset-password" element={<ResetPassword />} />
      <Route path="/rules" element={<Rules />} />
      <Route path="/about" element={<About />} />
      <Route path="/faq" element={<FAQ />} />
      <Route path="/terms" element={<Terms />} />
      <Route path="/privacy" element={<Privacy />} />
      <Route path="/cert/:id" element={<PublicCertificate />} />
      <Route path="/plans" element={<PlansWizard />} />
      <Route path="/payment-agents" element={<PaymentAgents />} />
      <Route path="/payment-agents/apply" element={<PaymentAgentsApply />} />
      <Route path="/checkout/:orderId" element={<ProtectedRoute><Checkout /></ProtectedRoute>} />
      <Route path="/checkout/:orderId/success" element={<ProtectedRoute><Checkout /></ProtectedRoute>} />

      <Route element={<ProtectedRoute><AppShell /></ProtectedRoute>}>
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/accounts" element={<Accounts />} />
        <Route path="/accounts/:id" element={<AccountDetail />} />
        <Route path="/payouts" element={<Payouts />} />
        <Route path="/certificates" element={<Certificates />} />
        <Route path="/affiliate" element={<Affiliate />} />
        <Route path="/settings" element={<Settings />} />
      </Route>

      <Route element={<AdminRoute><AdminShell /></AdminRoute>}>
        <Route path="/admin" element={<AdminOverview />} />
        <Route path="/admin/users" element={<AdminUsers />} />
        <Route path="/admin/accounts" element={<AdminAccounts />} />
        <Route path="/admin/orders" element={<AdminOrders />} />
        <Route path="/admin/phase2-requests" element={<AdminPhase2Requests />} />
        <Route path="/admin/funded-requests" element={<AdminFundedRequests />} />
        <Route path="/admin/payouts" element={<AdminPayouts />} />
        <Route path="/admin/affiliate-payouts" element={<AdminAffiliatePayouts />} />
        <Route path="/admin/promotions" element={<AdminPromotions />} />
        <Route path="/admin/payment-agents" element={<AdminPaymentAgents />} />
        <Route path="/admin/image-generator" element={<AdminImageGenerator />} />
        <Route path="/admin/payment-agent-applications" element={<AdminPaymentAgentApplications />} />
        <Route path="/admin/certificates" element={<AdminCertificates />} />
        <Route path="/admin/inventory" element={<AdminInventory />} />
      </Route>
    </Routes>
  );
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <TawkVisitor />
        <PromoBanner />
        <AnnouncementModal />
        <AppRouter />
      </BrowserRouter>
    </AuthProvider>
  );
}
